export const json = [
  {
  "_id": "harmonizacao_orofacial",
  "index": 0,
  tratamentoAtivo: false,
  "isActive": true,
  "image": require('@/assets/images/harmonizacao.png'),
  "titulo": "Hormonização orofacial",
  "conteudo": `A toxina botulínica tipo A ou Botox® como ficou conhecido e o preenchimento com ácido hialurônico, hoje em dia são os mais novos fármacos aliados a odontologia, e além de suas aplicações estéticas possuem uma ampla função terapêutica nas mais diferentes áreas da saúde.
  Podem ser utilizados em conjunto ou separadamente dependendo do caso a ser tratado e da localização, e suas principais indicações são a harmonização facial na finalização de casos, sorriso gengival ou “sorriso alto” onde a ocorre uma exposição exacerbada da gengiva ao sorrir, dores de cabeça e na face tensionais, nervealgia do trigêmeo, implantes com 
  carga imediata, bruxismo e briquismo (ranger e/ou apertar os dentes), correção de assimetria facial e desordens de movimento devido a musculatura da face, hipertrofia de masseter e
   disfunções da ATM.
   É um recurso terapêutico eficaz, seguro e consistente para diferentes abordagens, trazendo significante melhora na relação de qualidade de vida e autoestima dos pacientes. O tratamento consiste em uma neuromodulação muscular, onde a toxina age bloqueando a condução neuromuscular.
Apresenta alto impacto nos tratamentos de diferentes doenças, favorecendo o objetivo do tratamento de reabilitação e não necessita de anestesia para aplicação. A dose e o número de pontos devem ser adaptados as necessidades dos pacientes, baseados em suas características e localização dos músculos a serem tratados.
Botox® e preenchimento nos oferece uma excelente opção de tratamento de simples aplicação, indolor e com excelente perfil de segurança para uma harmonização facial.
`  }
,{
  "_id": "clareamento_dental",
  "index": 0,
  tratamentoAtivo: true,
  "isActive": true,
  "image": require('@/assets/images/clareamento.png'),
  "titulo": "Clareamento dental",
  "conteudo": `
  <h4>Clareamento</h4>
  Pelo método tradicional – da moldeira – ou com o moderno sistema de clareamento a laser, este é um tratamento dos mais efetivos no campo da estética dental.<br>
  <h4>Com Moldeira</h4>
  Neste caso, um molde, denominado “moldeira”, confeccionado sob medida para o cliente, é preenchido com o gel clareador e aplicado aos dentes. O tratamento é feito em casa, usando-se a moldeira algumas horas por dia. Normalmente é usada à noite, logo depois do jantar. Os resultados já serão visíveis em uma a duas semanas depois do início da aplicação.

<h4> Laser</h4>
No Clareamento a Laser, equipamentos de ponta são usados na clínica e o resultado é quase imediato, bastando algumas sessões. É a melhor indicação para quem busca clareamento rápido, pensando em eventos e atividades sociais, como festas e casamentos. 
  `  },
{
  "_id": "ortodontia",
  "index": 0,
  "isActive": true,
  tratamentoAtivo: true,

  "image": require('@/assets/images/ortodontia.png'),
  "titulo": "Ortodontia",
  "conteudo": `
  <h4>O que é ortodontia? 
  </h4>
  Ortodontia é uma especialidade odontológica que corrige a posição dos dentes e dos ossos maxilares posicionados de forma inadequada. Dentes tortos ou dentes que não se encaixam corretamente são difíceis de serem mantidos limpos, podendo ser perdidos precocemente, devido à deterioração e à doença periodontal. Também causam um estresse adicional aos músculos de mastigação que pode levar a dores de cabeça, síndrome da ATM e dores na região do pescoço, dos ombros e das costas. Os dentes tortos ou mal posicionados também prejudicam a sua aparência.

O tratamento ortodôntico torna a boca mais saudável, proporciona uma aparência mais agradável e dentes com possibilidade de durar a vida toda. 
<br><br><h4>Como saber se preciso de um ortodontista?
</h4>
<ul class="ui list">
<li><strong>Sobremordida</strong>, algumas vezes chamada de <strong>"dentes salientes"</strong> - este problema é caracterizado por um excesso vertical da região anterior da maxila e/ou uma sobre-erupção dos dentes dessa região. Nos casos de sobremordida, os dentes anteriores superiores recobrem quase 100% dos dentes inferiores, conferindo um sorriso desagradável e problemas mastigatórios. Os dentes inferiores podem, inclusive, estar tocando no palato e na gengiva do arco superior.</li>
<li><strong>Mordida cruzada anterior</strong> - quando a arcada inferior está projetada muito à frente ou a arcada superior se posiciona muito atrás.
</li>
<li><strong>Mordida cruzada</strong>  - ocorre quando a arcada superior não fica ligeiramente à frente da arcada inferior ao morder normalmente.</li>
<li><strong> Mordida aberta</strong>  -  espaço entre as superfícies de mordida dos dentes anteriores e/ou laterais quando os dentes posteriores se juntam.</li>
<li><strong> Desvio de linha mediana</strong>  - ocorre quando o centro da arcada superior não está alinhado com o centro da arcada inferior. </li>
<li><strong> Diastema  </strong>  - falhas, ou espaços, entre os dentes como resultado de dentes ausentes ou dentes que não preenchem a boca. </li>
<li><strong> Apinhamento </strong>  - ocorre quando existem dentes demais para se acomodarem na arcada dentária pequena.</li>
<h4>Como funciona um tratamento ortodôntico eficaz? 
</h4>
Diversos tipos de aparelhos, tanto fixos como móveis, são utilizados para ajudar a movimentar os dentes, retrair os músculos e alterar o crescimento mandibular. Estes aparelhos funcionam colocando uma leve pressão nos dentes e ossos maxilares. A gravidade do seu problema é que irá determinar qual o procedimento ortodôntico mais adequado e mais eficaz.
<br>
Aparelhos podem ser:<br>

<li><strong> Aparelho fixo  </strong>  - este é o tipo mais comum de aparelho; consiste de bandas, fios e/ou braquetes. As bandas são fixadas em volta de vários dentes ou um só dente, e utilizadas como âncoras para o aparelho, enquanto que os braquetes são presos na parte externa do dente. Os fios em forma de arco passam através dos braquetes e são ligados às bandas. Apertando-se o arco, os dentes são tracionados, movendo-se gradualmente em direção à posição correta. Os aparelhos fixos são geralmente apertados a cada mês para se obter os resultados desejados, que podem ocorrer no prazo de alguns meses até alguns anos. Atualmente eles são menores, mais leves e exibem bem menos metal que no passado. Podem apresentar cores vivas para as crianças, bem como estilos mais claros, preferidos por muitos adultos. </li>
<li><strong> Aparelho fixo autoliguaveis  </strong>  -aparelhos de ultima geração. Não utilizao mais as liguaduras de borracha, diminuindo consideralvelmente o atrito entre o aparelho e o fio, reduzindo em ate 40% o tempo de tratamento e como também o numero de visitas ao dentista.</li>
<li><strong> Aparelho Invisalign  </strong>  - são placas de acetato transparente moveis que movimentam os dentes sem a necessidade do uso de aparelhos fixos, são mais confortáveis e o Maximo em estética. </li>

</ul>
  `  },
{
  "_id": "endodontia_canal",
  "index": 0,
  "isActive": true,
  tratamentoAtivo: true,

  "image": require('@/assets/images/canal.png'),
  "titulo": "Endodontia (canal)",
  "conteudo": `
  Na Zapparoli Odontologia você conta com o melhor tratamento em Endodontia (especialidade que trata do Canal do dente) com profissionais qualificados e aparelhos de última geração.

<h4>Oque é Endodontia?
</h4>
É o famoso “tratamento de canal” responsável pela prevenção e tratamento das doenças da polpa do dente.
<h4>
O que é polpa dentária?
</h4>
A polpa dentária é um tecido conjuntivo especializado, localizado no interior do dente, que
devido a sua constituição e ligações tem a função primordial de tornar o órgão dentário reativo a estímulos (como agressões e mudanças de temperatura).
<h4>
O que é o tratamento de canal?
</h4>
O tratamento de canal baseia-se na remoção da polpa dental, uma estrutura viva que contém, entre outros elementos, nervos e vasos sanguíneos. Podemos encontrar de 1 a 4 ou mais canais em um único dente.
<h4>
Quando é indicado o tratamento de canal?
</h4>
De modo geral, o tratamento é indicado em duas situações:
<ol class="ui list">
  <li>Quando a polpa vital se apresenta inflamada, com dor espontânea (pulpite) devido à cárie profunda, fratura da coroa, retração gengival, etc;
  </li>
  <li>Quando a polpa perde a vitalidade (polpa necrosada) e compromete a estrutura que envolve a raiz, provocando inflamação da membrana periodontal e do osso.
  </li>
</ol>

<h4>
O tratamento de canal pode ser rápido?

</h4>
Depende da qualidade do dente (se não estiver infectado) e na experiência e habilidade profissional. Se as condições forem positivas o tratamento será realizado em apenas uma sessão

<h4>
Quando é preciso realizar várias sessões para o tratamento de canal?
</h4>

Na presença de pus, hemorragia persistente, tumefação ou em retratamentos e casos especiais, os tratamentos de canal podem ser realizados em várias sessões.<br>
Para evitar complicações com sua saúde, consulte a <strong>Zapparoli Odontologia </strong>regularmente.




  `  },

{
  "_id": "Implante_dentário",
  "index": 0,
  "isActive": true,
  tratamentoAtivo: true,

  "image": require('@/assets/images/implante.png'),
  "titulo": "Implante dentário",
  "conteudo": `
<h4>O Problema:
</h4>

<ul class="ui list">
  <li>Falta de dente ou dentes</li>
  <li>Problema de mastigação / mordida
  </li>
  <li>Vontade de melhorar a mastigação
  </li>
  <li>Vontade de ter uma solução permanente ao invés da dentadura
  </li>
</ul>

  <h4>O Tratamento:

  </h4>

  O Implante de dente é um tratamento para substituir as raízes dos dentes. O implante é cirurgicamente colado no osso da mandíbula ou maxila, e um dente artificial é colocado sobre o implante, criando um aparência natural. No caso de haver mais de um dente, há duas opções: 
  <strong>vários implantes podem ser colocados ou uma série de dentes artificiais (prótese fixa).</strong><br>
  Em geral, leva-se de 3 a 6 meses para que o implante cirúrgico seja cicatrizado antes da colocação do dente artificial.

<h4>Vantagens:</h4>
Implante com dente artificial é o mais próximo de se ter um dente natural. Eles são fortes, duráveis e praticamente imperceptíveis. Ao preencher o espaço entre os dentes, os implantes provêm melhor mastigação, resolvendo os problemas de mordida. É uma solução bem melhor do que as dentaduras móveis.
  `  },
  {
    "_id": "Protese",
    "index": 0,
    "isActive": true,
    tratamentoAtivo: true,
    "image": require('@/assets/images/protese.png'),
    "titulo": "Prótese",
    "conteudo": `Não há nada mais desagradável do que a perda de dentes, seja ela provocada pela cárie, traumatismos ou doenças das gengivas, que são a principal causa. A falta de dentes pode alterar as funções mastigatória, estética e fonética. Para sanar o problema pode-se utilizar as próteses.
<h4>Quais os tipos de próteses? 
</h4>
As próteses dentárias podem ser removíveis (o paciente pode tirá-las sempre que desejar) , ou fixas (com uma cola especial e só o dentista poderá removê-las).
<h4>Como são as próteses removíveis?
</h4>
Existem dois tipos de próteses removíveis: as parciais e as totais. As parciais removíveis podem ser totalmente em acrílico ou terem uma parte metálica chamada “esqueleto” e destinam-se a substituir um ou mais dentes. (também conhecidas como esqueléticas)
As totais removíveis são normalmente em acrílico e destinam-se à substituição de todos os dentes.
<h4>Quais são as próteses fixas?</h4>
As próteses dentárias podem ser removíveis (o paciente pode tirá-las sempre que desejar) , ou fixas (com uma cola especial e só o dentista poderá removê-las).
<h4>Como são as próteses removíveis?
</h4>
Existem dois tipos de próteses removíveis: as parciais e as totais. As parciais removíveis podem ser totalmente em acrílico ou terem uma parte metálica chamada “esqueleto” e destinam-se a substituir um ou mais dentes. (também conhecidas como esqueléticas)
As totais removíveis são normalmente em acrílico e destinam-se à substituição de todos os dentes.

<h4>Quais são as próteses fixas?</h4>
As próteses fixas são constituídas por <strong>coroas, pontes e coroas Richmond.</strong>
<h4>Oque são coroas?
</h4>
Nossos dentes são formados por duas estruturas: coroa e raiz. A coroa é a parte do dente que fica exposta, ou seja. Toda parte do dente que conseguimos enxergar fora de gengiva.

<h4>Qual é a indicação para se utilizar as coroas?
</h4>
A perda de parte da coroa natural que pode acontecer por algum tipo de trauma ou por cárie, pode ser solucionada com uma coroa protética. Elas funcionam como uma espécie de “capa” que irá reconstruir a cora natural do dente parcialmente destruído.

<h4>Quais os tipos de materiais utilizados?
</h4>
Resina acrílica e porcelanas. Para dar maior resistência, pode-se utilizar estruturas internas de metal (ligas de ouro ou ligas alternativas).
<h4>Qual a diferença entre resina e porcelana?</h4>
A resina é um material de manuseio mais simples que a porcelana. Apresenta um maior desgaste e, com o tempo, a alteração da cor também é maior. A porcelana apresenta maior dureza e estabilidade de cor e supre melhor o quesito estético.

<h4>Como a coroa é fixada ao dente?
</h4>
0 próprio encaixe sobre o dente desgastado já é uma forma de retenção, que será melhorada com agentes cimentantes específicos que, além de aumentarem a retenção, irão promover o vedamento.

<h4>Oque é ponte?
</h4>
A ponte é uma restauração protésica destinada a substituir um ou mais dentes, apoiando-se em dentes vizinhos ao espaço desdentado. As falhas deixadas pelos dentes ausentes podem fazer com que os demais dentes se movam para espaços vazios, provocando mordidas erradas.

<h4>Como são feitas as pontes (prótese fixa)?
</h4>
Assim como no caso da produção de uma coroa, para se providenciar a ponte, o dente (ou dentes) deve ser reduzido em seu tamanho de modo que a coroa ou ponte se encaixe perfeitamente sobre o preparo. Após a redução do dente/dentes, seu dentista fará um molde exato para a confecção da coroa ou ponte.


  `  },
  {
    "_id": "periodontia",
    "index": 0,
    "isActive": true,
    tratamentoAtivo: true,
    "image": require('@/assets/images/periodontia.png'),
    "titulo": "Periodontia",
    "conteudo": `
    <h4>O Problema:</h4>
    <ul class="ui list">
    <li>Retração gengival    </li>
    <li>Sangramento da gengiva    </li>
    <li>Doença genvigal</li>
</ul>

<h4>O Tratamento:</h4>
Os tratamentos periodontais são diversos e vão desde a prevenção da doença gengival até enxertos gengivais.


<h4>Conheça alguns dos nossos serviçoes em periodontia:
</h4>
<h4>O que é gengivite?
</h4>
Gengivite - uma inflamação da gengiva - é o estágio inicial da doença da gengiva e a mais fácil de ser tratada. A causa direta da doença é a placa - uma película, grudento e sem cor de bactérias que se forma, de maneira constante, nos dentes e na gengiva.
<br>
Se a placa não for removida pela escovação e uso de fio dental diários, ela produz toxinas (venenos) que irritam a mucosa da gengiva causando a gengivite. Neste estágio inicial da doença da gengiva, os danos podem ser revertidos, uma vez que o osso e o tecido conjuntivo que segura os dentes no lugar ainda não foram atingidos. Entretanto, se a gengivite não for tratada, ela pode evoluir para uma periodontite e causar danos permanentes aos dentes e mandíbula/maxilar.
<h4>Como sei que tenho gengivite?</h4>
Uma boa higiene bucal é essencial. A limpeza profissional também é extremamente importante, pois uma vez que a placa se acumula e endurece (ou torna-se tártaro), apenas o dentista ou um higienista podem removê-la.
<h4>Você pode prevenir a gengivite pela:</h4>
<ul class="ui list">
<li>A correta escovação e uso apropriado do fio dental para remover placas e restos, e do controle do aparecimento de tártaro.
</li>
<li>Alimentação correta para garantir nutrição adequada para o osso da mandíbula/maxilar e dos dentes.
</li>
<li>Evitar cigarros e outras formas de tabaco.</li>
<li>Ir ao dentista regularmente.</li>
<sub>Fonte: Colgate Palmolive Company

</sub>
<br>
<strong>Retração Gengival</strong>
</ul>
<h4>
O que é retração gengival?
</h4>
A causa não é fácil de determinar. Existem várias hipóteses: traumatismo por escovação (fricção exagerada com escova de cerdas duras); inflamação da gengiva pela presença da placa bacteriana; trauma oclusal (forças excessivas sobre o dente causadas por má posição dentária ou por restaurações ©altasª); restaurações desadaptadas na região gengival; posição alta dos freios labiais e lingual; movimentos ortodônticos realizados de maneira incorreta; dentes apinhados (encavalados); pouca espessura do osso que recobre a raiz.

<h4>Por que nessa situação os dentes ficam mais sensíveis?
</h4>
Devido à exposição da raiz, a camada que a reveste (cemento) desaparece, expondo a dentina, que é sensível. Bochechos com soluções fluoretadas podem amenizar o problema.

<h4>Tem relação com a idade?</h4>
Uma certa retração gengival generalizada é percebida com o passar dos anos e considerada normal. Algumas pessoas são mais susceptíveis que outras. A retração pode avançar em alguns períodos e, em outros, permanecer estacionária.
<h4>Existe tratamento?</h4>
Normalmente, o que se faz é evitar a evolução desse processo por intermédio de escovação adequada, limpeza profissional, ajuste oclusal, remoção de hábitos nocivos, remoção de excessos de materiais restau- radores, se houver, e, se for o caso, corrigir a má posição do dente com aparelho ortodôntico.

<h4>É possível recobrir a raiz novamente?</h4>
Sim, por intermédio de técnicas cirúrgicas utilizadas principalmente em retração de um ou no máximo dois dentes. São cirurgias de resultados não previsíveis, em que, em determinadas situações, vale a pena tentar. São feitas principalmente visando à estética.
<h4>Se não se fizer a cirurgia, pode-se perder o dente?</h4>
A retração, por si só, não provoca a perda do dente, desde que as causas sejam eliminadas e que não haja inflamação.<br>
<sub>Fonte: Revista APCD</sub>

    `  }

];